import React from 'react';
import Note from './Note';

const NoteList = ({ notes, onDeleteNote, activeNote, setActiveNote, setFavoriteNote, setCompleteNote, filteredNotes }) => {
    return (
        <div className='app-sidebar'>
            {filteredNotes.map((note) => (
                <Note
                    key={note.id}
                    note={note}
                    onDeleteNote={onDeleteNote}
                    activeNote={activeNote}
                    setActiveNote={setActiveNote}
                    setFavoriteNote={setFavoriteNote}
                    setCompleteNote={setCompleteNote}
                />
            ))}
        </div>
    );
}

export default NoteList;